<template>
  <v-row>
    <view-user
      :user-id="selectedUserId"
      v-model="isViewUserDialogVisible"
      @clearUserIdAndAuths="clearUserIdAndAuths()"
      @getUsers="getSequencePeople()"
    />
    <v-col cols="12" class="d-flex align-center justify-space-between py-0">
      <span class="kbDarkBlueText--text text-h6 pl-2">{{ $t('general.listView') }}</span>
      <div class="d-flex align-center">
        <v-btn class="mr-2"
               color="mainButtons"
               outlined
               @click="exportSequencePeople()">
          {{ $t('general.export') }}
        </v-btn>
      </div>
    </v-col>

    <v-col cols="12">
      <slot name="steps-row" />
    </v-col>

    <v-col cols="12" class="pt-0">
      <div>
        <v-data-table
          fixed-header
          :headers="tableHeaders"
          :height="dataTableHeight"
          :items="sequencePeople"
          item-key="sequenceId"
          :loading="loadingSequencePeople"
          :options.sync="localPagination"
          :footer-props="{
            'items-per-page-text': `${$t('general.sequencePeople')} ${$t('general.perPage')}`,
            'items-per-page-options': [50, 100, 200]
          }"
          :server-items-length="totalSequencePeople"
          class="elevation-2 mt-4"
          :must-sort="false">
          <template v-slot:item="{ item }">
            <tr class="kbDarkBlueText--text">
              <td>
                <div>
                  <span class="kbDarkBlueText--text font-weight-bold text-capitalize">
                    {{ item.name }}
                  </span>
                </div>
              </td>

              <td>
                <div class="d-flex align-center justify-center">
                  <v-icon :color="getStepColor(getStepById(item.stepId).type)"
                          class="mr-2"
                          x-small>
                    mdi-circle
                  </v-icon>
                  <span class="text-capitalize mr-4">{{ getStepById(item.stepId).name }}</span>
                </div>
              </td>

              <td>
                <div>
                  <span>
                    {{ item.email }}
                  </span>
                </div>
              </td>

              <td>
                <div>
                  <span>
                    {{ item.phone }}
                  </span>
                </div>
              </td>

              <td>
                <div class="text-center">
                  <span class="text-capitalize">
                    {{ convertTZToUserTZ(item.createdAt) | moment('MMMM Do YYYY') }}
                  </span>
                </div>
              </td>

              <td>
                <div class="text-center">
                  <v-btn color="kbDarkBlueText"
                         class="mr-1"
                         icon
                         @click="viewUser(item.userId)">
                    <v-icon>mdi-eye</v-icon>
                  </v-btn>

                  <v-menu left>
                    <template v-slot:activator="{ on }">
                      <v-btn icon color="kbDarkBlueText" v-on="on">
                        <v-icon size="25px">mdi-dots-vertical</v-icon>
                      </v-btn>
                    </template>

                    <v-list color="kbLight">
                      <v-list-item @click="changeUserFromSequence(item.userId)">
                        <v-list-item-action>
                          <v-icon color="kbDarkBlueText">mdi-file-tree</v-icon>
                        </v-list-item-action>
                        <v-list-item-title
                          class="kbDarkBlueText--text"
                        >{{ $t('general.changeUserFromSequence') }}</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="deleteUserFromSequence(item.userId)">
                        <v-list-item-action>
                          <v-icon color="kbDarkBlueText">mdi-delete</v-icon>
                        </v-list-item-action>
                        <v-list-item-title
                          class="kbDarkBlueText--text"
                        >{{ $t('general.deleteUserFromSequence') }}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </div>
              </td>
            </tr>
          </template>

          <template v-slot:no-data>
            <v-row>
              <v-col
                class="text-center"
                v-if="loadingSequencePeople"
                cols="12"
              >
                {{ $t('general.loading') }} {{ $t('general.people') }}
              </v-col>
              <v-col
                class="red--text text-center"
                v-else
                cols="12"
              >
                {{ $t('general.noPeopleRegistered') }}
              </v-col>
            </v-row>
          </template>
        </v-data-table>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import ViewUser from '@/pages/App/People/dialogs/ViewUser/ViewUser'
import ModuleTableHeight from '@/mixins/ModuleTableHeight'
import TimeZones from '@/mixins/TimeZones'
export default {
  components: { ViewUser },
  computed: {
    ...mapGetters(['appUuid', 'companyUuid']),
    ...mapState({
      sequencePeople: state => state.sequences.sequencePeople,
      sequenceSteps: state => state.sequences.sequenceSteps,
      totalSequencePeople: state => state.sequences.totalSequencePeople
    }),
    localPagination: {
      get () {
        return this.pagination
      },
      set (value) {
        if (this.canChangePagination) {
          console.log('Pagination change from leads list view ', value)
          this.onPaginationChange(value)
        }
        this.canChangePagination = true
      }
    },
    tableHeaders () {
      return [
        { text: this.$t('general.name'), value: 'name', align: 'left', sortable: true },
        { text: this.$t('general.step'), value: 'step', align: 'center', sortable: true },
        { text: this.$t('general.email'), value: 'email', align: 'left', sortable: true },
        { text: this.$t('general.phone'), value: 'phone', align: 'left', sortable: true },
        { text: this.$t('general.creationDate'), value: 'createdAt', align: 'center', sortable: true },
        { text: this.$t('general.actions'), value: '', align: 'center', sortable: false }
      ]
    }
  },
  data () {
    return {
      canChangePagination: false,
      isViewUserDialogVisible: false,
      loadingSequencePeople: false,
      method: 'create',
      options: {},
      selectedUserId: ''
    }
  },
  methods: {
    changeUserFromSequence (userId) {
      this.$emit('changeUserFromSequence', userId)
    },
    clearUserIdAndAuths () {
      this.selectedUserId = ''
    },
    deleteUserFromSequence (userId) {
      this.$emit('deleteUserFromSequence', userId)
    },
    exportSequencePeople () {
      // TODO: Export sequence people function
      console.log('Export sequence people')
    },
    getSequencePeople () {
      this.$emit('getSequencePeople')
    },
    getStepById (stepId) {
      if (!this.sequenceSteps ||
          !Array.isArray(this.sequenceSteps) ||
          this.sequenceSteps.length === 0) return this.$t('general.withoutStep')
      const step = this.sequenceSteps.find(item => item.id === stepId)
      if (step) {
        const { name, type } = step
        return { name, type }
      }
      return this.$t('general.withoutStep')
    },
    getStepColor (stepType) {
      switch (stepType) {
        case 'email':
          return 'kbRed'
        case 'task':
          return 'kbOrange'
        case 'sms':
          return 'kbBlue'
        case 'call':
          return 'kbGreen'
        default:
          return 'kbRed'
      }
    },
    onPaginationChange (pagination) {
      this.$emit('onPaginationChange', pagination)
    },
    viewUser (userId) {
      this.selectedUserId = userId
      this.isViewUserDialogVisible = true
    }
  },
  mixins: [ModuleTableHeight, TimeZones],
  props: {
    pagination: {
      type: Object,
      required: true
    }
  }
}
</script>
